import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/undraw_no_data.svg'


const _withScopeId = n => (_pushScopeId("data-v-11a43ecb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-desktop" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { id: "visitors-filter" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Attendance status", -1))
const _hoisted_5 = {
  key: 2,
  class: "flex-desktop",
  style: {"justify-content":"space-between"}
}
const _hoisted_6 = { class: "flex-desktop full-width" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"30px"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "Attendance status")
], -1))
const _hoisted_8 = { style: {"margin-right":"10px"} }
const _hoisted_9 = { style: {"width":"20%"} }
const _hoisted_10 = { style: {"position":"relative","bottom":"45px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Visitors", -1))
const _hoisted_12 = {
  class: "ion-text-right",
  id: "click-trigger"
}
const _hoisted_13 = {
  key: 6,
  class: "image"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"width":"50vw","margin":"4rem auto 0","display":"block"}
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-text-center" }, "Nobody registered yet!", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]

import { chevronDown, addOutline } from "ionicons/icons";
import {
  IonContent,
  IonPage,
  IonGrid,
  IonSearchbar,
  IonRadioGroup,
  IonRadio,
  IonPopover,
  IonRow,
  IonProgressBar,
  IonLabel,
  IonItem,
  IonFab,
  IonFabButton,
  IonCol,
  IonButton,
  IonIcon,
  IonRefresher,
  IonRefresherContent,
  onIonViewWillEnter,
} from "@ionic/vue";
import { useAppStore } from "@/stores/app";
import { useContextStore } from "@/stores/context";
import { useVisitorsStore } from "@/stores/visitors";
import { computed, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { IVisitor, IVisitorTypeChoice } from "@/models/visitor";
import { IUserCard } from "@/views/_partials";
import UserCard from "@/views/_partials/UserCard.vue";
import { getVisitorTypeChoices } from "@/api/visitors";
import EventSidebar from "@/views/_partials/EventSidebar.vue";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'Visitors',
  setup(__props) {

const { isMobile } = useWindowWidth();
const appStore = useAppStore();
const contextStore = useContextStore();
const visitorsStore = useVisitorsStore();
const visitorTypeChoices = ref([] as IVisitorTypeChoice[]);
const route = useRoute();

const dark_mode = computed(() => appStore.settings.theme === "dark");

const state = reactive({
  empty: false,
  filter_selected: "",
});

const form = {
  search: "",
  visitor_type: "",
  checkin_status: "",
};

const inital_checkin_status = route.params.checkin_status as string;

const params = {
  search: "",
  visitor_type: "",
  checkin_status: "",
  visitor_status: "registered",
  event: contextStore.event.id,
  page: 1,
  page_size: 10,
  reset: false,
};

const more = () => {
  params.page = params.page + 1;
  params.reset = false;
  visitorsStore.fetch(params);
};

const search = () => {
  params.search = form.search;
  params.page = 1;
  params.reset = true;
  visitorsStore.fetch(params);
};

const cardConfig = (visitor: IVisitor) => {
  const config: IUserCard = {
    name: visitor.name,
    detail: visitor.email,
    picture: visitor.profile_picture,
    checkin_status: visitor.checkin_status,
  };
  return config;
};

const handleRefresh = async (event: any) => {
  params.checkin_status = "";
  state.filter_selected = "registered";

  await visitorsStore.fetch({ ...params, reset: true });
  await getVisitorTypeChoices({ event: contextStore.event.id }).then(
    (response) => {
      visitorTypeChoices.value = response.data.results;
    }
  );
  if (event.target) {
    event.target.complete();
  }
};

const filterByStatus = async (status: string) => {
  params.checkin_status = status;

  await visitorsStore.fetch({ ...params, reset: true }).then(() => {
    if (visitorsStore.results.length === 0) {
      state.empty = true;
    } else {
      state.empty = false;
    }
  });
  getVisitorTypeChoices({ event: contextStore.event.id }).then((response) => {
    visitorTypeChoices.value = response.data.results;
  });
};

onIonViewWillEnter(() => {
  params.page = 1;

  state.filter_selected = inital_checkin_status ? inital_checkin_status : "";
  params.checkin_status = inital_checkin_status ? inital_checkin_status : "";

  visitorsStore.fetch({ ...params, reset: true }).then(() => {
    if (visitorsStore.results.length === 0) {
      state.empty = true;
    } else {
      state.empty = false;
    }
  });
  getVisitorTypeChoices({ event: contextStore.event.id }).then((response) => {
    visitorTypeChoices.value = response.data.results;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (_unref(isMobile))
            ? (_openBlock(), _createBlock(_unref(IonRefresher), {
                key: 0,
                slot: "fixed",
                onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (handleRefresh($event)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRefresherContent))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(EventSidebar, {
                  key: 0,
                  event: _unref(contextStore).event
                }, null, 8, ["event"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(dark_mode.value ? 'full-width' : 'colored-bg full-width')
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h1", _hoisted_3, [
                  _createTextVNode(" All visitors "),
                  (visitorTypeChoices.value.length > 0)
                    ? (_openBlock(), _createBlock(_unref(IonIcon), {
                        key: 0,
                        icon: _unref(chevronDown)
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true)
                ]),
                (visitorTypeChoices.value.length > 0)
                  ? (_openBlock(), _createBlock(_unref(IonPopover), {
                      key: 0,
                      reference: "trigger",
                      trigger: "visitors-filter",
                      side: "bottom",
                      alignment: "start",
                      "trigger-action": "click"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonContent), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonRadioGroup), { value: "all" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visitorTypeChoices.value, (visitorTypeChoice) => {
                                  return (_openBlock(), _createBlock(_unref(IonItem), {
                                    key: `visitor-type-${visitorTypeChoice.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(visitorTypeChoice.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_unref(IonRadio), {
                                        value: visitorTypeChoice.visitor_type
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(isMobile))
                  ? (_openBlock(), _createBlock(_unref(IonGrid), { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), { size: "6" }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonCol), { size: "3" }, {
                              default: _withCtx(() => [
                                _createElementVNode("small", null, _toDisplayString(_unref(contextStore).event.checked_in_visitors) + " of " + _toDisplayString(_unref(contextStore).event.registered_visitors), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonProgressBar), {
                                  style: {"margin-top":"0.6rem"},
                                  value: 
                      _unref(contextStore).event.checked_in_visitors /
                      _unref(contextStore).event.registered_visitors
                    
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("small", null, _toDisplayString(_unref(contextStore).event.checked_in_visitors) + " of " + _toDisplayString(_unref(contextStore).event.registered_visitors), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(IonProgressBar), {
                            style: {"margin-top":"0.6rem"},
                            value: 
                      _unref(contextStore).event.checked_in_visitors /
                      _unref(contextStore).event.registered_visitors
                    
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_unref(IonFabButton), {
                          color: "primary",
                          "router-link": `/event/${_unref(contextStore).event.id}/add-visitors`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["router-link"])
                      ])
                    ])),
                (!state.empty)
                  ? (_openBlock(), _createBlock(_unref(IonItem), {
                      key: 3,
                      class: "ion-margin-top ion-margin-bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSearchbar), {
                          placeholder: "Search visitors",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (search())),
                          modelValue: form.search,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.search) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonGrid), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRow), { class: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_12, [
                              _createTextVNode(" Status "),
                              _createVNode(_unref(IonIcon), { icon: _unref(chevronDown) }, null, 8, ["icon"])
                            ]),
                            _createVNode(_unref(IonPopover), {
                              reference: "trigger",
                              trigger: "click-trigger",
                              side: "bottom",
                              alignment: "start",
                              "trigger-action": "click",
                              "dismiss-on-select": true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonContent), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonRadioGroup), {
                                      modelValue: state.filter_selected,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.filter_selected) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonItem), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonLabel), null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("All Visitors")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(IonRadio), {
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (filterByStatus(''))),
                                              value: ""
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonItem), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonLabel), null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Registered")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(IonRadio), {
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (filterByStatus('registered'))),
                                              value: "registered"
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonItem), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonLabel), null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Entered")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(IonRadio), {
                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (filterByStatus('checkedin'))),
                                              value: "checkedin"
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonItem), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonLabel), null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Checked out")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(IonRadio), {
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (filterByStatus('checkedout'))),
                                              value: "checkedout"
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visitorsStore).results, (visitor, index) => {
                  return (_openBlock(), _createBlock(UserCard, {
                    user: cardConfig(visitor),
                    route: `/event/${_unref(contextStore).event.id}/visitor/${visitor.id}`,
                    key: `visitor-${index}`
                  }, null, 8, ["user", "route"]))
                }), 128)),
                (_unref(visitorsStore).loading)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(new Array(5), (empty, index) => {
                      return (_openBlock(), _createBlock(UserCard, {
                        key: `visitor-${index}`
                      }))
                    }), 128))
                  : _createCommentVNode("", true),
                (_unref(visitorsStore).results.length < _unref(visitorsStore).item_count)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 5,
                      expand: "block",
                      color: "dark",
                      fill: "clear",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (more())),
                      style: {"margin":"1rem 0"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" See more ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (state.empty && !_unref(visitorsStore).loading)
                  ? (_openBlock(), _createElementBlock("figure", _hoisted_13, _hoisted_17))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFab), {
            key: 0,
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed",
            style: {"margin-right":"0.5rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonFabButton), {
                color: "primary",
                "router-link": `/event/${_unref(contextStore).event.id}/add-visitors`
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["router-link"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})